module.exports = __webpack_public_path__ + "static/media/simple.434b06cf.svg";